import styled from 'styled-components'
import { COLORS } from 'utils'

interface IPhantomProps {
  phantomHeight?: string
  bottomPosition?: string
}

export const Phantom = styled.div<IPhantomProps>`
  display: block;
  padding: 20px;
  height: ${props => props.phantomHeight ? props.phantomHeight : '102px'};
  width: 100%;
`

export const Footer = styled.footer<IPhantomProps>`
 background-color: white;
 border-top: 2px solid ${COLORS.blueFonts};
 position: fixed;
 width: 89.5vw;
 bottom: ${props => props.bottomPosition ? props.bottomPosition : '0'};
 color: white;
`

